export const TEST_ID = 'baseEquipmentCard';
